// This check protects the local identity selection. Every protected API must also validate its JWT.
export async function verifySession(client, session) {
  if (!session?.access_token) return null;
  const { data, error } = await client.auth.getUser(session.access_token);
  if (error) throw new Error('No se pudo verificar tu sesión. Comprueba la conexión y vuelve a acceder.');
  const user = data?.user;
  if (!user?.id || !user.email || !user.email_confirmed_at || user.id !== session.user?.id) throw new Error('La sesión no es válida o el correo está pendiente de confirmar.');
  return user;
}
export function sessionCoordinator({ client, prepare, accept, reject }) {
  let revision = 0; let disposed = false; let preparedId = null;
  return {
    async update(session) {
      if (disposed) return;
      const current = ++revision;
      if (!session) { preparedId = null; accept(null); return; }
      try {
        const user = await verifySession(client, session);
        if (disposed || revision !== current) return;
        if (user.id !== preparedId) { prepare(user); preparedId = user.id; }
        accept(user);
      } catch (error) { if (!disposed && revision === current) { preparedId = null; reject(error); } }
    },
    dispose() { disposed = true; revision++; },
  };
}
